var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"d-flex ctabs align-items-center"},_vm._l((_vm.items),function(item,iIndex){return _c('div',{key:`item-${iIndex}`,staticClass:"ctab-item font-weight-bold px-2",class:{ selected: _vm.selectedTab == item },on:{"click":function($event){_vm.selectedTab = item;
        _vm.$emit('update:selected', item);}}},[_vm._v("\n      "+_vm._s(item)+"\n    ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }